import { NS } from '~/utils/ns';
import common from './common.json';
import profile from './profile.json';
import dashboard from './dashboard.json';
import report from './report.json';

export default {
  [NS.common]: common,
  [NS.profile]: profile,
  [NS.dashboard]: dashboard,
  [NS.report]: report,
};
